import {
  AfterContentInit,
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  OnInit,
  ViewEncapsulation
} from '@angular/core';
import { FormService } from '../../shared/form.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { PaymentService } from '../../services/payment.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { filter, catchError, debounceTime, distinctUntilChanged, tap } from 'rxjs/operators';
import { SharedService } from '../../shared/shared.service';
import { of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { TrackService } from 'src/app/services/track.service';
import { ProposalService } from 'src/app/shared/proposal.service';


interface IXOptions {
  stepIndex: number;
  progress: number;
  footerContent?: string;
  leftButtonsList?: [];
  rightButtonsList?: [];
  outlet?: any;
  backArrow?: any;
  formDisabled?: boolean;
  newCar: boolean;
}

const XDefaults: IXOptions = {
  stepIndex: 0,
  progress: 0,
  footerContent: '',
  leftButtonsList: [],
  rightButtonsList: [],
  backArrow: null,
  outlet: null,
  formDisabled: false,
  newCar: false
};

@Component({
  selector: 'app-policyholder-details',
  templateUrl: './policyholder-details.component.html',
  styleUrls: ['./policyholder-details.component.scss'],
  encapsulation: ViewEncapsulation.None,
  // changeDetection: ChangeDetectionStrategy.OnPush
})
export class PolicyholderDetailsComponent implements OnInit, AfterViewInit, AfterContentInit {
  parentForm;
  formGroupName = 'personInsurerData';
  data: any = {};
  phoneCodes = [];
  phoneMask = '00 000 0000';
  phoneSeparator = [' '];
  deactivateMask = false;
  phonePattern;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private chRef: ChangeDetectorRef,
    public formService: FormService,
    public sharedService: SharedService,
    public http: HttpClient,
    public proposalService: ProposalService,
    public formBuilder: FormBuilder,
    public trackService: TrackService) {
    this.parentForm = this.formService.currentForm;
    let formData = this.formService.currentForm.getRawValue();
    if (formData.ownerData.egn.length == 10 && formData.samePerson == "Y") {
      this.formService.currentForm.patchValue({ policyholderData: formData.ownerData });

      this.router.navigate(['/summary']);
    }

    let data = this.route.data['value'];
    if (data) {
      this.updateControl(data);
    } else {
      this.router.events
        .pipe(filter(event => event instanceof NavigationEnd))
        .subscribe((event: NavigationEnd) => {
          data = this.route.snapshot?.data;
          this.updateControl(data);
        });
    }
  }

  get phoneNumber() {
    return this.parentForm.controls.policyholderData.get('phoneNumber');
  }
  get countryCode() {
    return this.parentForm.controls.policyholderData.get('countryCode');
  }


  private markFormGroupTouched(formGroup: FormGroup) {
    (<any>Object).values(formGroup.controls).forEach(control => {
      control.markAsUntouched();

      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }

  updateFormControl(path) {
    this.formService.currentForm.get(path).patchValue(true);
  }

  updateControl(snapshotData) {
    if (snapshotData?.formGroupName) {
      this.formGroupName = snapshotData.formGroupName;
    }
    Object.assign(this.data, snapshotData);
  }

  trackByIndex(index: number) {
    return index;
  };

  ngAfterViewInit() {
  }

  ngAfterContentInit() {
    // this.markFormGroupTouched(this.formService.currentForm);
  }

  clearContactDetails(details) {
    ['eik', 'companyName', 'phoneNumber', 'egn', 'firstName', 'middleName', 'lastName', 'firstNameInLatin', 'middleNameInLatin', 'lastNameInLatin', 'addressInLatin', 'email'].map(item => {
      if (details[item]) {
        delete details[item];
      }
    });
    return details
  }

  ngOnInit(): void {
    this.parentForm = this.formService.currentForm;
    // this.validationService.registerControl(this.parentForm.controls.errorControl);
    this.sharedService.getPhoneCodes().subscribe((res) => {
      this.phoneCodes = res.map(function(el: any) { return el.value; });
      if (this.parentForm.controls.samePerson.value == "N") {
        if (!this.parentForm.controls.policyholderData.controls.countryCode.value) {
          this.parentForm.controls.policyholderData.controls.countryCode.setValue(this.parentForm.controls.firstCountryCode.value);
          this.parentForm.controls.ownerData.controls.countryCode.setValue('+' + this.phoneCodes[0]);
        }
      }

    });

    this.parentForm.get('policyholderData.countryCode').valueChanges.subscribe((mobileCode) => {
      if (mobileCode !== '+359') {
        this.deactivateMask = true;
        this.phonePattern = '[0-9]{0,15}'
        this.parentForm.get('policyholderData.phoneNumber').updateValueAndValidity();
      } else {
        this.deactivateMask = false;
        this.phonePattern='^((?!(0))[0-9]{9})$'
        this.parentForm.get('policyholderData.phoneNumber').updateValueAndValidity();
      }

    });
  }


  toText(value): string {
    return value ? value.toUpperCase() : null;
  }

  myFilter(search, itemValue) {
    if (!search) {
      return itemValue.match(new RegExp('^1', 'g')) !== null;
    }
    return itemValue.match(new RegExp('^' + search, 'g')) !== null;
  }

}
